export const environment = {
  production: true,
  intercom: 'f5ob0ttv',
  stripe: 'pk_live_bhUU1KrKPIJ2Hpk7jWKpSFi6',
  socketIo: 'https://ws.siftrock.com',
  integratedHelpInteractionId: 277089,
  googleClientId: '87492603950-06lrmkk2pqqtt3unjnr1f0thunu6badp.apps.googleusercontent.com'
};



// WEBPACK FOOTER //
// ./client/environments/environment.ts